import {
  Grid,
  Typography,
} from '@mui/material';
import * as Styles from '../../../../../../../assets/styles/appStyles';
import { ServePreferences } from '../../../../../../../Models/Departments/Details/ServePreferences';
import CheckboxInput from '../../../../../../AddLocation/Components/UI/CheckboxInput';
import { gridContainer, infoGridItem } from '../../../../../Styles/CustodianAddressDetailsStyles';

export default function PatientInfo({
  servePreferences,
}: {
  servePreferences: ServePreferences | undefined;
}) {
  return (
    <Grid rowSpacing={3} container sx={gridContainer} spacing={2}>
      <Grid container item rowSpacing={3}>
        <Grid item xs={12} sx={infoGridItem}>
          <Typography align="left" sx={Styles.labelTitle}>
            Patient
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <CheckboxInput
                label="Patient Address"
                keyName={'servePreferences.isPatientAddress'}
                checked={servePreferences?.isPatientAddress}
                onChange={() => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>

            <Grid item xs={6}>
              <CheckboxInput
                label="Patient Account Number"
                keyName={`servePreferences.isPatientAccountNumber`}
                checked={servePreferences?.isPatientAccountNumber}
                onChange={() => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>

            <Grid item xs={6}>
              <CheckboxInput
                label="Patient Full SSN Number"
                keyName={`servePreferences.isPatientFullSSNNumber`}
                checked={servePreferences?.isPatientFullSSNNumber}
                onChange={() => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>

            <Grid item xs={6}>
              <CheckboxInput
                label="Patient Initial Sensitive Information"
                keyName={`servePreferences.isPatientInitialSensitiveInformation`}
                checked={servePreferences?.isPatientInitialSensitiveInformation}
                onChange={() => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>

            <Grid item xs={6}>
              <CheckboxInput
                label="Electronic Signature Accepted"
                keyName={`servePreferences.isElectronicSignatureAccepted`}
                checked={servePreferences?.isElectronicSignatureAccepted}
                onChange={() => { }}
                onBlur={() => { }}
                disabled={false}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
